module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc32",
      "id": "dd32"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "id": "page_p0035-03-2_20_january"
    }
  }, [_vm._v("January")]), _vm._v(" 30")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary30"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0035-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Let us run with endurance the race that is set before us, looking unto Jesus, the author and finisher of our faith.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0035-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("f anyone desires to come after Me, let him deny himself, and take up his cross daily, and follow Me. • Whoever of you does not forsake all that he has cannot be My disciple. • Therefore let us cast off the works of darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-05-6"
    }
  }, [_vm._v("Everyone who competes for the prize is temperate in all things. Now they do it to obtain a perishable crown, but we for an imperishable crown. Therefore I run thus: not with uncertainty. Thus I fight: not as one who beats the air. But I discipline my body and bring it into subjection, lest, when I have preached to others, I myself should become disqualified. • Brethren, I do not count myself to have apprehended; but one thing I do, forgetting those things which are behind and reaching forward to those things which are ahead, I press toward the goal for the prize of the upward call of God in Christ Jesus. • Let us know, let us pursue the knowledge of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 12:1–2; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 9:23; 14:33; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 13:12; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 9:25–27; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 3:13–14; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OS")]), _vm._v(". 6:3")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary30"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0035-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("It is good for a man to bear the yoke in his youth.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0035-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("rain up a child in the way he should go, and when he is old he will not depart from it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-10-16"
    }
  }, [_vm._v("We have had human fathers who corrected us, and we paid them respect. Shall we not much more readily be in subjection to the Father of spirits and live? For they indeed for a few days chastened us as seemed best to them, but He for our profit, that we "), _c('span', {
    attrs: {
      "id": "page_p0035-03-2_26_may"
    }
  }, [_vm._v("may")]), _vm._v(" be partakers of His holiness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-11-19"
    }
  }, [_vm._v("Before I was afflicted I went astray, but now I keep Your word. . . . It is good for me that I have been afflicted, that I may learn Your statutes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-11-20"
    }
  }, [_vm._v("For I know the thoughts that I think toward you, says the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", thoughts of peace and not of evil, to give you a future and a hope. • Humble yourselves under the mighty hand of God, that He may exalt you in due time.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(". 3:27; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROV")]), _vm._v(". 22:6; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 12:9–10; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 119:67, 71; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(". 29:11; 1 P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" 5:6")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b075de32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter32.vue
// module id = 159
// module chunks = 0